import { MessageTypeEnum, PriorityEnum } from '@schemax-whatsapp/shared-models';
import { PrimaryGeneratedColumn, Index, Entity, Column, ManyToOne, JoinColumn, OneToMany, CreateDateColumn, UpdateDateColumn, VersionColumn, Generated } from 'typeorm';
import { CompanyBiMessage } from './company-bi-message.entity';


@Entity('company')
export class Company {

    @PrimaryGeneratedColumn('increment', {
        name: 'company_id'
    })
    companyId: number;

    @Column("varchar", {
        nullable: false,
        name: "company_code",
        length: 40
    })
    companyCode: string;

    @Column("varchar", {
        nullable: false,
        name: "company_name",
        length: 100
    })
    companyName: string;

    @Column("text", {
        nullable: false,
        name: "address",
    })
    address: string;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @OneToMany(type => CompanyBiMessage, biMsg => biMsg.company, { cascade: true })
    companyBiMessages: CompanyBiMessage[];
}

